import EmptyLogo from './assets/pvl_empty_state.svg?react';

const EmptyDeviationList = () => (
    <div
        data-testid='empty-deviation-list'
        className='position-relative display-flex h-90-percent width-100pct align-items-center justify-content-center'
    >
        <div className='display-flex size-200px align-items-center justify-content-center rounded-full bg-primary'>
            <EmptyLogo />
        </div>
        <div className='position-absolute h-200px width-100pct'>
            <div className='position-absolute inset-x-0 top-minus-130px display-flex flex-column align-items-center justify-content-center'>
                <h2 className='mb-10 text-center text-bold text-primary'>ALL GOOD!</h2>
                <span className='text-center text-h4 text-primary'>
                    Incoming cards will appear
                    <br />
                    here automatically
                </span>
            </div>
            <div className='position-absolute -bottom-50 display-flex width-100pct align-items-center justify-content-center'>
                <span className='text-center text-h4 text-primary'>Go grab a coffee</span>
            </div>
        </div>
    </div>
);

export default EmptyDeviationList;
